<template>
  <v-tooltip top>
    <v-btn fab dark :disabled="disabled" small color="pink" slot="activator" @click="del()">
      <v-icon>delete</v-icon>
    </v-btn>
    <span>Delete</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
  },
  methods: {
    del() {
      this.$emit("del");
    }
  }
};
</script>

<style>
</style>
